<template>
  <div :class="$style['pagination-wrapper']">
    <paginate
      ref="pagination"
      :page-count="pageCount"
      :click-handler="onPageChange"
      :page-range="1"
      next-class="paginate-next"
      prev-class="paginate-prev"
      page-class="paginate-page"
    >
      <span slot="prevContent">
        <ds-arrow-icon
          :default-rotation="180"
          fill="#1da1f2"
        />
        <span :class="$style['navigation-text']">
          {{ prevButtonText }}
        </span>
      </span>
      <span slot="nextContent">
        <span :class="$style['navigation-text']">
          {{ nextButtonText }}
        </span>
        <ds-arrow-icon
          :default-rotation="0"
          fill="#1da1f2"
        />
      </span>
    </paginate>
  </div>
</template>

<script>
import Paginate from "vuejs-paginate";
import DsArrowIcon from "../icons/ds-arrow-icon";

export default {
  name: "DsPagination",
  components: {
    Paginate,
    DsArrowIcon
  },
  props: {
    pageCount: {
      type: Number,
      default: 0
    },
    prevButtonText: {
      type: String,
      default: "Prev"
    },
    nextButtonText: {
      type: String,
      default: "Next"
    }
  },
  mounted: function() {
    this.$emit("refInitialized", this.$refs.pagination);
  },
  methods: {
    onPageChange: function(page) {
      this.$emit("pageChanged", page);
    }
  }
};
</script>

<style lang="scss" module>
@import "../../scss/_variables.scss";
@import "../../scss/_mixins.scss";

.pagination-wrapper {
  padding: 10px 20px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 600;
  @include mobile() {
    padding: 10px;
  }
  ul {
    text-align: right;
    @include mobile() {
      text-align: center;
    }
    li {
      margin: 0px 5px;
      display: inline-block;
      * {
        outline: none;
        user-select: none;
      }
      svg {
        display: initial !important;
      }
      a {
        color: $blue-color;
        &:hover {
          color: $blue-color;
        }
      }
    }
  }
}
.navigation-text {
  @include mobile() {
    display: none;
  }
}
</style>
<style lang="scss">
@import "../../scss/_variables.scss";
@import "../../scss/_mixins.scss";

$SIZE: 35px;

.paginate-prev {
  svg {
    margin-right: 10px;
  }
}
.paginate-next {
  svg {
    margin-left: 10px;
  }
}
.paginate-page {
  width: $SIZE;
  height: $SIZE;
  a {
    width: $SIZE;
    height: $SIZE;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.paginate-page,
.paginate-prev,
.paginate-next {
  a {
    > span {
      display: flex;
    }
  }
}
@include mobile() {
  .paginate-page,
  .paginate-prev,
  .paginate-next {
    a {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .paginate-next,
  .paginate-prev {
    svg {
      margin-left: 0px;
      margin-right: 0px;
    }
  }
}
.paginate-page:first-child {
  margin-right: 30px;
}
.paginate-page:last-child {
  margin-left: 30px;
}
.active {
  background-color: $blue-color !important;
  border-radius: 50px !important;
  a {
    color: #fff !important;
    &:hover {
      color: #fff !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../panel-theme/src/js/widgets/ds-pagination.vue